import React from "react";
import { withGoogleMap, withScriptjs, GoogleMap } from "react-google-maps";
import { MarkerWithLabel } from "react-google-maps/lib/components/addons/MarkerWithLabel";
import PropTypes from "prop-types";
import withParcelLines from "./withParcelLines"

const buildMarkers = (props) => {
  const markerElems = props.markers.map((marker) => {
    return (
      <MarkerWithLabel
        key={marker.ordinal}
        position={{
          lat: marker.latitude,
          lng: marker.longitude,
        }}
        labelAnchor={{ x: 4.5, y: 35 }}
        labelStyle={{
          backgroundColor: "#ea4335",
          color: "White",
          fontSize: "14px",
          fontWeight: "bold",
          margin: "2px",
          borderRadius: "5px",
        }}
        draggable={props.draggable && (marker.isCurrentProject || props.markers.length === 1)}
        onDragEnd={marker.isCurrentProject || props.markers.length === 1 ? props.onMarkerChange : null}
      >
        <div>
          {marker.ordinal === 0
            ? ""
            : marker.ordinal + (marker.isCurrentProject ? "*" : "")}
        </div>
      </MarkerWithLabel>
    );
  });

  return markerElems;
};

const Map = (props) => {
  const markers = buildMarkers(props);
  const currentProjectMarker =
    props.markers.find((m) => m.isCurrentProject) || props.markers[0];

  return (
    <GoogleMap
      defaultZoom={19}
      center={{
        lat: currentProjectMarker.latitude,
        lng: currentProjectMarker.longitude,
      }}
      options={{
        mapTypeId: "hybrid",
        mapTypeControl: false,
        tilt: 0,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        panControl: false,
        gestureHandling: "greedy",
      }}
    >
      {markers}
    </GoogleMap>
  );
};

Map.propTypes = {
  draggable: PropTypes.bool,
  onMarkerChange: PropTypes.func.isRequired,
  markers: PropTypes.arrayOf(
    PropTypes.shape({
      latitude: PropTypes.number,
      longitude: PropTypes.number,
      ordinal: PropTypes.number,
      isCurrentProject: PropTypes.bool,
    })
  ),
};

Map.defaultProps = {
  draggable: false,
  markers: [],
};

export default withScriptjs(withGoogleMap(withParcelLines(Map)));
